// rolex preowned menu toggle script
document.addEventListener("DOMContentLoaded", function () {
    const toggleButton = document.querySelector(".cpo-menu-button");
    const mobileMenu = document.querySelector(".cpo-navigation-mobile-wrapper");
    const toggleIcon = document.querySelector(".cpo-menu-button");
  
    if (!toggleButton || !mobileMenu || !toggleIcon) return;
  
    toggleButton.addEventListener("click", function (e) {
      e.preventDefault();
  
      if (mobileMenu.hasAttribute("active")) {
        // Hide menu
        mobileMenu.removeAttribute("active");
        toggleIcon.removeAttribute("active");
      } else {
        // Show menu
        mobileMenu.setAttribute("active", "");
        toggleIcon.setAttribute("active", "");
      }
    });
});

document.addEventListener('DOMContentLoaded', function () {
  // Initialize the sliders for Feature Product and Keep Exploring
  const sliders = [
      { selector: '#feature-product-slider', perPage: 4 },
      { selector: '#related-products-slider', perPage: 3 },
      { selector: '#keep-exploring-slider', perPage: 4 }
  ];

  sliders.forEach(sliderConfig => {
      const element = document.querySelector(sliderConfig.selector);
      if (element) {
          new Splide(sliderConfig.selector, {
              type: 'slide',
              perPage: sliderConfig.perPage,
              pagination: true,
              arrows: true,
              gap: '8px',
              breakpoints: {
                  1023: { perPage: 3 },
                  767: { perPage: 2 }
              }
          }).mount();
      }
  });
});

// Rolex Preowned Banner Slider
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.rolex-preowned-banner-slider').forEach(slider => {
    const showArrows = slider.dataset.showArrows === 'true';
    const showPagination = slider.dataset.showPagination === 'true';

    new Splide(slider, {
      type: 'slide',
      perPage: 1,
      arrows: showArrows,
      pagination: showPagination,
      autoplay: false,
      interval: 5000,
      pauseOnHover: true,
    }).mount();
  });
});



// Rolex Preowned Model gallery
document.addEventListener('DOMContentLoaded', function () {
  // Initialize the product gallery once the document is ready
  initializeProductGallery();
  initialize360Viewer();
});

function initializeProductGallery() {
  const openSliderButton = document.getElementById('openSliderButton');
  const sliderPopup = document.getElementById('sliderPopup');
  const closeSliderButton = document.getElementById('closeSliderButton');

  // Ensure required elements are present
  if (!sliderPopup || !closeSliderButton) {
      console.warn('Product gallery popup elements not found.');
      return;
  }

  initMainGallery();
  init360ImageSlider();
  bindPopupEvents(openSliderButton, sliderPopup, closeSliderButton);
}

function initMainGallery() {
  const gallery = new Splide('#rolex-preowned-gallery', {
      type: 'loop',
      perPage: 1,
      perMove: 1,
      pagination: true,
      arrows: true,
      autoplay: false,
  });

  const thumbs = new Splide('#rolex-preowned-gallery-thumbs', {
      perPage: 4,
      isNavigation: true,
      gap: 8,
      focus: 'center',
      pagination: false,
      arrows: false,
      speed: 50
  });

  thumbs.on('mounted', function () {
      thumbs.Components.Elements.slides.forEach((thumb, index) => {
          thumb.addEventListener('click', () => {
              gallery.go(index + 1);
              thumb.classList.add('is-active');
          });

          thumb.addEventListener('keydown', function(e) {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              thumb.click();
            }
          });
      });
  });

  gallery.on('move', function (index) {
      const thumbIndex = index - 1;
      if (thumbIndex >= 0 && thumbIndex < thumbs.length) {
          thumbs.go(thumbIndex);
      } else {
          thumbs.Components.Elements.slides.forEach(slide => {
              slide.classList.remove('is-active');
          });
      }
  });

  let run = 0;
  thumbs.on('active', function (index) {
      if (run <= 1) {
          thumbs.Components.Elements.slides.forEach(slide => {
              slide.classList.remove('is-active');
          });
      }
      run++;
  });

  gallery.mount();
  thumbs.mount();
}

function init360ImageSlider() {
  new Splide('#rolex-preowned-gallery360', {
      perPage: 1,
      perMove: 1,
      pagination: true,
      arrows: true,
      autoplay: false,
      drag: false,
  }).mount();
}

function bindPopupEvents(openButton, popup, closeButton) {
  openButton.addEventListener('click', function () {
      popup.style.display = 'grid'; // Show the popup
  });

  closeButton.addEventListener('click', function () {
      popup.style.display = 'none'; // Hide the popup
  });

  openButton.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      openButton.click();
    }
  });
}

function initialize360Viewer() {
  const viewer = document.querySelector('.gallery360__viewer');
  if (!viewer) {
      console.warn('360 viewer element not found.');
      return;
  }

  const images = viewer.querySelectorAll('img');
  if (images.length === 0) {
      console.warn('No images found for 360 viewer.');
      return;
  }

  let frame = 0;
  const totalImages = images.length;
  const threshold = 45;

  // Activate the first image
  updateActiveImage(images, frame);

  // Impetus for left-right drag interaction
  new Impetus({
      source: viewer,
      multiplier: 1.5,
      friction: 0.85,
      boundY: [0, 0], // Prevent vertical movement
      update: (x) => {
          const newFrame = calculateFrame(x, threshold, totalImages);
          if (newFrame !== frame) {
              updateActiveImage(images, newFrame);
              frame = newFrame;
          }
      },
  });
}

function updateActiveImage(images, frame) {
  images.forEach((image) => image.classList.remove('active'));
  images[frame].classList.add('active');
}

function calculateFrame(x, threshold, totalImages) {
  let frame = Math.floor(-x / threshold) % totalImages;
  return frame < 0 ? totalImages + frame : frame;
}



document.addEventListener("DOMContentLoaded", function () {

  function rolexPreownedAccordionInit() {
    // scope only this section
    const accordions = document.querySelectorAll(
      ".rolex-preowned_accordion .rolex-preowned_accordion-item"
    );

    if (!accordions.length) return false;

    function updateHeight(content) {
      if (!content) return;
      requestAnimationFrame(() => {
        content.style.maxHeight = content.scrollHeight + "px";
      });
    }

    accordions.forEach(function (item, index) {
      const header = item.querySelector(".accordion-header");
      const content = item.querySelector(".rolex-preowned_accordion-content");

      if (!header || !content) {
        console.warn("[Shopify Accordion] Missing header/content", item);
        return;
      }

      // accessibility
      header.setAttribute("aria-expanded", "false");

      // Default open first
      if (index === 0) {
        item.classList.add("open");
        header.setAttribute("aria-expanded", "true");
        updateHeight(content);
      } else {
        content.style.maxHeight = "0px";
      }

      function openAccordion() {
        item.classList.add("open");
        header.setAttribute("aria-expanded", "true");
        updateHeight(content);
      }

      function closeAccordion() {
        item.classList.remove("open");
        header.setAttribute("aria-expanded", "false");
        content.style.maxHeight = "0px";
      }

      // Toggle click
      header.addEventListener("click", function () {
        if (item.classList.contains("open")) {
          closeAccordion();
        } else {
          openAccordion();
        }
      });

      // MutationObserver (dynamic form / success / steps)
      const observer = new MutationObserver(function () {
        if (item.classList.contains("open")) {
          updateHeight(content);
        }
      });

      observer.observe(content, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ["style", "class", "data-step"]
      });

      // Image load fix
      const imgs = content.querySelectorAll("img");
      imgs.forEach((img) => {
        if (!img.complete) {
          img.addEventListener("load", () => {
            if (item.classList.contains("open")) {
              updateHeight(content);
            }
          });
        }
      });
    });

    // Window load safety
    window.addEventListener("load", function () {
      accordions.forEach((item) => {
        if (item.classList.contains("open")) {
          const content = item.querySelector(".rolex-preowned_accordion-content");
          if (content) {
            content.style.maxHeight = content.scrollHeight + "px";
          }
        }
      });
    });

    return true;
  }

  rolexPreownedAccordionInit();
});


// skip links js
document.addEventListener('DOMContentLoaded', function () {

  const links = document.querySelectorAll('.skip-links .skip-link');
  if (!links.length) return;

  links.forEach(function (link) {

    link.addEventListener('click', function (event) {
      event.preventDefault();

      const targetId = this.getAttribute('data-target');
      if (!targetId) return;

      const target = document.getElementById(targetId);
      if (!target) return;

      // --- Smooth scroll ---
      try {
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      } catch (e) {
        // Fallback
        target.scrollIntoView(true);
      }

      // --- Move keyboard focus for accessibility ---
      setTimeout(function () {
        const hadTabindex = target.hasAttribute('tabindex');

        if (!hadTabindex) {
          // Make it temporarily focusable
          target.setAttribute('tabindex', '-1');
        }

        try {
          target.focus({ preventScroll: true });
        } catch (e) {
          // Older browsers
          target.focus();
        }

        // Clean up if we added tabindex
        if (!hadTabindex) {
          setTimeout(() => target.removeAttribute('tabindex'), 800);
        }

      }, 300);
    });

  });

});

document.addEventListener("DOMContentLoaded", function () {

  const body = document.body;

  /* -------------------------------------------
     1) Check if Rolex header exists anywhere
  -------------------------------------------- */
  if (document.querySelector(".cpo-rolex-header")) {
    body.classList.add("has-rolex");
  }

  /* -------------------------------------------
     2) Run only if has-rolex present
  -------------------------------------------- */
  if (!body.classList.contains("has-rolex")) return;

  // Keyboard (Tab) → add keyfocus
  document.addEventListener("keydown", function (e) {
    if (e.key === "Tab") {
      body.classList.add("keyfocus");
    }
  });

  // Mouse → remove keyfocus
  document.addEventListener("mousedown", function () {
    body.classList.remove("keyfocus");
  });

});


/* Enable Enter key to toggle checkbox (accessibility enhancement) */
document.querySelectorAll('.rolex-preowned-filter__option input').forEach(function(input) {
  input.addEventListener('keydown', function(e) {
    if (e.key === 'Enter') {
      e.preventDefault();
      input.checked = !input.checked;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });
});

/* Rolex Preowned Globo form enhancements */
(function () {
  'use strict';

  var FORM_WRAPPER_SELECTOR = [
    '.preowned-product-send-message',
    '.preowned-product-appointment',
    '.page-send-message-form',
    '.page-appointment-form',
    '.preowned-appointment-form',
    '.message-form',
    '.appointment-form',
    '.preowned-form-wrapper'
  ].join(', ');

  var STEP_CONTROL_SELECTOR = [
    '[data-action-next]',
    '[data-action-previous]',
    '[data-action-prev]',
    '[data-action-back]',
    '[data-next-text]',
    '[data-prev-text]',
    '[data-previous-text]',
    '.gfb__line-button',
    '.gfb__sticky-navigation-next',
    '.gfb__sticky-navigation-previous',
    '.next-block',
    '.backtoblock'
  ].join(', ');

  var STEP_PANEL_SELECTOR = [
    '.globo-form-app .panel',
    '.globo-form-app .block-container',
    '.wizard__content .panel',
    '.wizard__content .block-container',
    '.panels > .panel',
    '.panels > .block-container',
    '.block-container[data-step]'
  ].join(', ');

  var ACTIVE_STEP_PANEL_SELECTOR = [
    '.globo-form-app .panel.movingIn',
    '.globo-form-app .panel.is-active',
    '.globo-form-app .panel.active',
    '.globo-form-app .block-container.movingIn',
    '.globo-form-app .block-container.is-active',
    '.globo-form-app .block-container.active',
    '.wizard__content .panel.movingIn',
    '.wizard__content .panel.is-active',
    '.wizard__content .panel.active',
    '.wizard__content .block-container.movingIn',
    '.wizard__content .block-container.is-active',
    '.wizard__content .block-container.active',
    '.panels > .panel.movingIn',
    '.panels > .panel.is-active',
    '.panels > .panel.active',
    '.panels > .block-container.movingIn',
    '.panels > .block-container.is-active',
    '.panels > .block-container.active',
    '.panel[aria-hidden="false"]',
    '.block-container[aria-hidden="false"]'
  ].join(', ');

  var SCREEN_TEXT_SKIP_SELECTOR = [
    '.help-block.error',
    '.globo-form-error',
    '.gfb__error',
    '.invalid-feedback',
    '[role="alert"]'
  ].join(', ');

  var pendingStepWatchers = new WeakMap();
  var nextStepSignaturesBeforeClick = new WeakMap();
  var locationInitFrame = null;

  function onReady(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
      return;
    }

    callback();
  }

  function toArray(collection) {
    return Array.prototype.slice.call(collection || []);
  }

  function uniqueElements(elements) {
    var seen = [];

    return elements.filter(function (element) {
      if (seen.indexOf(element) !== -1) return false;
      seen.push(element);
      return true;
    });
  }

  function dispatchBubblingEvent(element, eventName) {
    var event;

    if (typeof Event === 'function') {
      event = new Event(eventName, { bubbles: true, cancelable: true });
    } else {
      event = document.createEvent('Event');
      event.initEvent(eventName, true, true);
    }

    element.dispatchEvent(event);
  }

  function dispatchMouseEvent(element, eventName) {
    var event;

    if (typeof MouseEvent === 'function') {
      event = new MouseEvent(eventName, {
        bubbles: true,
        cancelable: true,
        view: window
      });
    } else {
      event = document.createEvent('MouseEvents');
      event.initMouseEvent(eventName, true, true, window, 1);
    }

    element.dispatchEvent(event);
  }

  function findFormWrapper(element) {
    var productAppointment;
    var appointmentWrapper;

    if (!element || !element.closest) return null;

    productAppointment = element.closest('.preowned-product-appointment');
    if (productAppointment) return productAppointment;

    appointmentWrapper = element.closest('.preowned-appointment-wrapper');
    if (appointmentWrapper && appointmentWrapper.querySelector('.preowned-appointment-form, .preowned-appointment-blocks')) {
      return appointmentWrapper;
    }

    return element.closest(FORM_WRAPPER_SELECTOR) ||
      element.closest('.preowned-product-appointment, .preowned-appointment-wrapper, .relative-form-wrapper');
  }

  function isDisabledControl(control) {
    return !control ||
      control.disabled ||
      control.hasAttribute('disabled') ||
      control.getAttribute('aria-disabled') === 'true' ||
      control.classList.contains('disabled') ||
      control.classList.contains('gfb__sticky-navigation-disabled');
  }

  function getControlText(control) {
    return control ? (control.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase() : '';
  }

  function isStepNavigationControl(control) {
    if (!control || isDisabledControl(control)) return false;
    if (control.matches('.wizard__submit') || control.getAttribute('type') === 'submit') return false;
    return !!findFormWrapper(control);
  }

  function isNextStepControl(control) {
    if (!control) return false;
    if (control.matches('[data-action-next], [data-next-text], .next-block')) return true;
    return control.matches('.gfb__line-button, .gfb__sticky-navigation-next') && getControlText(control) === 'next';
  }

  function getStepPanels(wrapper) {
    if (!wrapper) return [];
    return uniqueElements(toArray(wrapper.querySelectorAll(STEP_PANEL_SELECTOR)));
  }

  function isVisiblePanel(panel) {
    var style;
    var rect;

    if (!panel) return false;

    style = window.getComputedStyle(panel);
    if (style.display === 'none' || style.visibility === 'hidden') return false;

    rect = panel.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0;
  }

  function getActiveStepPanel(wrapper) {
    var panels = getStepPanels(wrapper);
    var visiblePanels;
    var activePanel = panels.filter(function (panel) {
      return panel.classList.contains('movingIn') && isVisiblePanel(panel);
    })[0];

    if (activePanel) return activePanel;

    activePanel = panels.filter(function (panel) {
      return panel.getAttribute('aria-hidden') === 'false' && isVisiblePanel(panel);
    })[0];

    if (activePanel) return activePanel;

    visiblePanels = panels.filter(isVisiblePanel);
    return visiblePanels.length === 1 ? visiblePanels[0] : null;
  }

  function findActiveStepTarget(wrapper) {
    if (!wrapper) return null;

    return toArray(wrapper.querySelectorAll(ACTIVE_STEP_PANEL_SELECTOR))
      .filter(isVisiblePanel)[0] || getActiveStepPanel(wrapper);
  }

  function getPanelStepValue(panel) {
    var stepElement;

    if (!panel) return '';
    if (panel.hasAttribute('data-step')) return panel.getAttribute('data-step') || '';

    stepElement = toArray(panel.querySelectorAll('[data-step]')).filter(isVisiblePanel)[0];
    return stepElement ? stepElement.getAttribute('data-step') || '' : '';
  }

  function getVisibleStepValues(wrapper) {
    if (!wrapper) return '';

    return toArray(wrapper.querySelectorAll('[data-step]'))
      .filter(isVisiblePanel)
      .map(function (stepElement) {
        return stepElement.getAttribute('data-step') || '';
      })
      .join('|');
  }

  function getStepSignature(wrapper) {
    var panels = getStepPanels(wrapper);
    var activePanel;
    var panelIndex;
    var stepValue;
    var visibleStepValues;

    if (!panels.length) return null;

    activePanel = getActiveStepPanel(wrapper);
    if (!activePanel) return null;

    panelIndex = panels.indexOf(activePanel);
    stepValue = getPanelStepValue(activePanel);
    visibleStepValues = getVisibleStepValues(wrapper);

    return panelIndex + ':' + stepValue + ':' + visibleStepValues;
  }

  function getWizardStateSignature(wrapper) {
    var stateElements;

    if (!wrapper) return '';

    stateElements = uniqueElements(toArray(wrapper.querySelectorAll([
      '.globo-form-app .panel',
      '.globo-form-app .block-container',
      '.wizard__content .panel',
      '.wizard__content .block-container',
      '.panels > .panel',
      '.panels > .block-container',
      '.gfb__indicator [class]',
      '.gfb__indicator--line [class]',
      '[aria-current="step"]'
    ].join(', '))));

    return stateElements.map(function (element, index) {
      var style = window.getComputedStyle(element);

      return [
        index,
        isVisiblePanel(element) ? 'visible' : 'hidden',
        element.getAttribute('data-step') || '',
        element.getAttribute('aria-hidden') || '',
        element.getAttribute('aria-current') || '',
        element.hasAttribute('hidden') ? 'hidden-attr' : '',
        style.display,
        style.visibility,
        element.className || ''
      ].join(':');
    }).join('|');
  }

  function getVisibleForm(wrapper) {
    if (!wrapper) return null;

    if (wrapper.matches('.preowned-appointment-form, .page-appointment-form, .message-form, .appointment-form') && isVisiblePanel(wrapper)) {
      return wrapper;
    }

    return toArray(wrapper.querySelectorAll('.preowned-appointment-form, .page-appointment-form, .message-form, .appointment-form'))
      .filter(isVisiblePanel)[0] || null;
  }

  function getVisibleGloboShell(wrapper) {
    var activeForm = getVisibleForm(wrapper) || wrapper;

    return toArray(activeForm.querySelectorAll([
      '.globo-form-app',
      '.globo-form.gfb__template__wizard1',
      'form.g-container',
      '.wizard__content',
      '.panels'
    ].join(', '))).filter(isVisiblePanel)[0] || null;
  }

  function getScreenTextSignature(element) {
    var textParts = [];

    if (!element) return '';

    function collectText(node) {
      var style;

      if (node.nodeType === 3) {
        textParts.push(node.nodeValue || '');
        return;
      }

      if (node.nodeType !== 1 && node.nodeType !== 9 && node.nodeType !== 11) return;

      if (node.nodeType === 1) {
        if (node.matches(SCREEN_TEXT_SKIP_SELECTOR)) return;
        if (node.hasAttribute('hidden') || node.getAttribute('aria-hidden') === 'true') return;

        style = window.getComputedStyle(node);
        if (style.display === 'none' || style.visibility === 'hidden') return;
      }

      toArray(node.childNodes).forEach(collectText);
    }

    collectText(element);

    return textParts.join(' ')
      .replace(/\s+/g, ' ')
      .trim()
      .slice(0, 1800);
  }

  function getVisibleScreenSignature(wrapper) {
    var screenTarget = findActiveStepTarget(wrapper) || getVisibleGloboShell(wrapper) || getVisibleForm(wrapper);

    if (!screenTarget) return '';

    return [
      screenTarget.tagName || '',
      screenTarget.getAttribute('data-step') || '',
      screenTarget.getAttribute('aria-hidden') || '',
      screenTarget.className || '',
      getScreenTextSignature(screenTarget)
    ].join(':');
  }

  function getAppointmentViewSignature(wrapper) {
    var viewElements;

    if (!wrapper) return '';

    viewElements = toArray(wrapper.querySelectorAll([
      '.preowned-appointment-form',
      '.page-appointment-form',
      '.preowned-appointment-blocks',
      '.preowned-appointment_header',
      '.preowned-appointment_content'
    ].join(', ')));

    return viewElements.map(function (element, index) {
      return [
        index,
        isVisiblePanel(element) ? 'visible' : 'hidden',
        element.getAttribute('data-id') || '',
        element.className || ''
      ].join(':');
    }).join('|');
  }

  function getFormViewSignature(wrapper) {
    var stepSignature = getStepSignature(wrapper);
    var wizardStateSignature = getWizardStateSignature(wrapper);
    var screenSignature = getVisibleScreenSignature(wrapper);
    var appointmentSignature = getAppointmentViewSignature(wrapper);
    var signatures = [];

    if (stepSignature) signatures.push(stepSignature);
    if (wizardStateSignature) signatures.push(wizardStateSignature);
    if (screenSignature) signatures.push(screenSignature);
    if (appointmentSignature) signatures.push(appointmentSignature);

    return signatures.length ? signatures.join('::') : null;
  }

  function getHeaderOffset() {
    var selectors = [
      '.cpo-rolex-header',
      '.shopify-section--header',
      '.Header',
      'header[role="banner"]'
    ];
    var offset = 24;

    selectors.forEach(function (selector) {
      toArray(document.querySelectorAll(selector)).forEach(function (header) {
        var style = window.getComputedStyle(header);
        var rect = header.getBoundingClientRect();
        var isPinned = style.position === 'fixed' || style.position === 'sticky';

        if (isPinned && rect.top <= 5 && rect.bottom > 0) {
          offset = Math.max(offset, Math.min(rect.height + 24, 180));
        }
      });
    });

    return offset;
  }

  function findScrollTarget(wrapper) {
    var activeStepTarget;
    var visibleGloboShell;
    var visibleForm;
    var targetSelectors = [
      '.preowned-appointment-form',
      '.page-appointment-form',
      '.page-send-message-form',
      '.preowned-product-send-message',
      '.preowned-product-appointment',
      '.message-form',
      '.appointment-form',
      '.relative-form-wrapper',
      '.rolex-preowned_accordion-content'
    ];
    var target = null;

    activeStepTarget = findActiveStepTarget(wrapper);
    if (activeStepTarget) return activeStepTarget;

    visibleGloboShell = getVisibleGloboShell(wrapper);
    if (visibleGloboShell) return visibleGloboShell;

    visibleForm = getVisibleForm(wrapper);
    if (visibleForm) return visibleForm;

    targetSelectors.some(function (selector) {
      target = wrapper.matches(selector) ? wrapper : wrapper.closest(selector);
      return !!target;
    });

    return target || wrapper;
  }

  function scrollTargetIntoView(target) {
    var rect;
    var scrollY;
    var headerOffset;
    var viewportHeight;
    var availableHeight;
    var destination;

    if (!target || !document.documentElement.contains(target)) return;

    rect = target.getBoundingClientRect();
    if (!rect.height) return;

    scrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
    headerOffset = getHeaderOffset();
    viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    availableHeight = Math.max(viewportHeight - headerOffset, 1);

    if (rect.height <= availableHeight * 0.82) {
      destination = scrollY + rect.top - headerOffset - ((availableHeight - rect.height) / 2);
    } else {
      destination = scrollY + rect.top - headerOffset - 20;
    }

    window.scrollTo({
      top: Math.max(0, Math.round(destination)),
      behavior: 'smooth'
    });
  }

  function afterNewStepPaint(callback) {
    requestAnimationFrame(function () {
      requestAnimationFrame(callback);
    });
  }

  function watchForStepChange(wrapper, beforeSignature) {
    var existingCleanup = pendingStepWatchers.get(wrapper);
    var observer;
    var timeoutIds = [];
    var queued = false;
    var complete = false;

    if (existingCleanup) existingCleanup();

    function cleanup() {
      complete = true;

      if (observer) observer.disconnect();
      timeoutIds.forEach(function (timeoutId) {
        window.clearTimeout(timeoutId);
      });

      pendingStepWatchers.delete(wrapper);
    }

    function scrollIfStillChanged() {
      afterNewStepPaint(function () {
        if (getFormViewSignature(wrapper) !== beforeSignature) {
          scrollTargetIntoView(findScrollTarget(wrapper));
        }
      });
    }

    function checkStep() {
      var currentSignature;

      queued = false;
      if (complete || !document.documentElement.contains(wrapper)) {
        cleanup();
        return;
      }

      currentSignature = getFormViewSignature(wrapper);

      if (currentSignature && currentSignature !== beforeSignature) {
        cleanup();
        scrollIfStillChanged();
      }
    }

    function queueCheck() {
      if (queued || complete) return;

      queued = true;
      requestAnimationFrame(checkStep);
    }

    observer = new MutationObserver(queueCheck);
    observer.observe(wrapper, {
      attributes: true,
      childList: true,
      subtree: true,
      attributeFilter: ['class', 'style', 'data-step', 'data-current-step', 'data-index', 'aria-current', 'aria-hidden', 'hidden']
    });

    pendingStepWatchers.set(wrapper, cleanup);

    queueCheck();
    [60, 160, 320, 650, 1200, 2200].forEach(function (delay) {
      timeoutIds.push(window.setTimeout(queueCheck, delay));
    });
    timeoutIds.push(window.setTimeout(cleanup, 2600));
  }

  function handleStepNavigationClick(event) {
    var control = event.target.closest ? event.target.closest(STEP_CONTROL_SELECTOR) : null;
    var wrapper;
    var beforeSignature;

    if (event.rolexPreownedNextScrollHandled) return;
    if (!isStepNavigationControl(control)) return;

    wrapper = findFormWrapper(control);
    beforeSignature = nextStepSignaturesBeforeClick.get(wrapper) || getFormViewSignature(wrapper);
    nextStepSignaturesBeforeClick.delete(wrapper);

    if (beforeSignature) {
      watchForStepChange(wrapper, beforeSignature);
    }
  }

  function handleNextStepNavigationClick(event) {
    var control = event.target.closest ? event.target.closest(STEP_CONTROL_SELECTOR) : null;

    if (!isNextStepControl(control)) return;
    handleStepNavigationClick(event);
    event.rolexPreownedNextScrollHandled = true;
  }

  function rememberNextStepSignature(event) {
    var control = event.target.closest ? event.target.closest(STEP_CONTROL_SELECTOR) : null;
    var wrapper;
    var beforeSignature;

    if (!isNextStepControl(control) || !isStepNavigationControl(control)) return;

    wrapper = findFormWrapper(control);
    if (nextStepSignaturesBeforeClick.has(wrapper)) return;

    beforeSignature = getFormViewSignature(wrapper);

    if (beforeSignature) {
      nextStepSignaturesBeforeClick.set(wrapper, beforeSignature);
      watchForStepChange(wrapper, beforeSignature);
      window.setTimeout(function () {
        if (nextStepSignaturesBeforeClick.get(wrapper) === beforeSignature) {
          nextStepSignaturesBeforeClick.delete(wrapper);
        }
      }, 2000);
    }
  }

  function rememberKeyboardNextStepSignature(event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    rememberNextStepSignature(event);
  }

  function getSingleLocationFields(root) {
    var fields = [];

    if (!root || (root.nodeType !== 1 && root.nodeType !== 9)) return fields;

    if (root.matches && root.matches('.single_location')) {
      fields.push(root);
    }

    return uniqueElements(fields.concat(toArray(root.querySelectorAll('.single_location'))));
  }

  function getRadioClickTarget(radio) {
    var option = radio.closest('.gfb__radio-wrapper, .globo-list-control, .radio-wrapper');

    if (option) {
      return option.querySelector('label.gfb__radio-label, label.globo-option, label') || option;
    }

    return radio.closest('label') || radio;
  }

  function selectRadioLikeUser(radio) {
    var clickTarget = getRadioClickTarget(radio);

    dispatchMouseEvent(clickTarget, 'mousedown');
    dispatchMouseEvent(clickTarget, 'mouseup');

    if (typeof clickTarget.click === 'function') {
      clickTarget.click();
    }

    if (!radio.checked && radio !== clickTarget && typeof radio.click === 'function') {
      radio.click();
    }

    if (radio.checked) {
      dispatchBubblingEvent(radio, 'input');
      dispatchBubblingEvent(radio, 'change');
    }
  }

  function initSingleLocationFields(root) {
    getSingleLocationFields(root).forEach(function (field) {
      var radios = toArray(field.querySelectorAll('input[type="radio"]')).filter(function (radio) {
        return !radio.disabled;
      });

      if (radios.length === 1 && !radios[0].checked) {
        selectRadioLikeUser(radios[0]);
      }
    });
  }

  function queueLocationInit(root) {
    if (locationInitFrame) {
      window.cancelAnimationFrame(locationInitFrame);
    }

    locationInitFrame = requestAnimationFrame(function () {
      locationInitFrame = null;
      initSingleLocationFields(root || document);
    });
  }

  function mutationTouchesForm(mutation) {
    var target = mutation.target;
    var addedNodes = toArray(mutation.addedNodes);

    if (target && target.closest && target.closest(FORM_WRAPPER_SELECTOR + ', .single_location')) {
      return true;
    }

    return addedNodes.some(function (node) {
      if (node.nodeType !== 1) return false;

      return (node.matches && node.matches(FORM_WRAPPER_SELECTOR + ', .single_location')) ||
        (node.querySelector && node.querySelector(FORM_WRAPPER_SELECTOR + ', .single_location')) ||
        (node.closest && node.closest(FORM_WRAPPER_SELECTOR + ', .single_location'));
    });
  }

  onReady(function () {
    var root = document.body || document.documentElement;
    var observer;

    document.addEventListener('pointerdown', rememberNextStepSignature, true);
    document.addEventListener('mousedown', rememberNextStepSignature, true);
    document.addEventListener('touchstart', rememberNextStepSignature, true);
    document.addEventListener('keydown', rememberKeyboardNextStepSignature, true);
    window.addEventListener('click', handleNextStepNavigationClick, true);
    document.addEventListener('click', handleStepNavigationClick, true);
    queueLocationInit(document);

    observer = new MutationObserver(function (mutations) {
      if (mutations.some(mutationTouchesForm)) {
        queueLocationInit(document);
      }
    });

    observer.observe(root, {
      childList: true,
      subtree: true
    });
  });
})();


/* Globo forms: remove non-interactive elements (headings, text, labels) from the tab order */
(function () {
  'use strict';

  var BACK_SELECTOR = '.cpo-form-accessibility .backtoblock .globo-paragraph, .cpo-form-accessibility .gfb__sticky-navigation-previous';
  var NON_INTERACTIVE = '.globo-paragraph[tabindex], .heading-title[tabindex], .heading-caption[tabindex], label[tabindex], .globo-label[tabindex], .globo-description[tabindex]';

  function cleanTabOrder(root) {
    var scope = (root && root.querySelectorAll) ? root : document;
    scope.querySelectorAll('.cpo-form-accessibility ' + NON_INTERACTIVE).forEach(function (el) {
      if (el.matches(BACK_SELECTOR)) return;
      el.removeAttribute('tabindex');
    });

    // Back controls stay keyboard accessible
    scope.querySelectorAll(BACK_SELECTOR).forEach(function (el) {
      el.setAttribute('role', 'button');
      el.setAttribute('aria-label', 'Back');
      if (el.classList.contains('gfb__sticky-navigation-disabled')) {
        el.removeAttribute('tabindex');
        el.setAttribute('aria-disabled', 'true');
      } else {
        if (el.getAttribute('tabindex') !== '0') el.setAttribute('tabindex', '0');
        el.removeAttribute('aria-disabled');
      }
    });
  }

  function init() {
    if (!document.querySelector('.cpo-form-accessibility')) return;
    cleanTabOrder(document);

    // Enter / Space activates the Back controls
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var el = e.target && e.target.closest && e.target.closest(BACK_SELECTOR);
      if (!el || el.getAttribute('aria-disabled') === 'true') return;
      e.preventDefault();
      (el.closest('.backtoblock') || el).click();
    });

    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () {
        queued = false;
        cleanTabOrder(document);
      });
    }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['tabindex'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
